import { render, staticRenderFns } from "./per-msg.vue?vue&type=template&id=7fa59e28&scoped=true&"
import script from "./per-msg.vue?vue&type=script&lang=js&"
export * from "./per-msg.vue?vue&type=script&lang=js&"
import style0 from "./per-msg.vue?vue&type=style&index=0&id=7fa59e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa59e28",
  null
  
)

export default component.exports